import { Box, getThemeColor, ThemeColors } from '@fairfashion/design-system'
import { Handle } from 'reactflow'
import { styled } from 'styled-components'

export const Node = styled(Box)`
  width: 220px;
  flex-direction: column;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing['2']};
  background: ${({ theme }) => theme.colors.custom.white};
  box-shadow: ${({ theme }) => theme.box_shadow.card};
  border-radius: 8px;
  padding: 12px;
  pointer-events: all;
  border: 1px solid ${({ theme }) => theme.colors.grey_5};
`

export const SegmentText = styled.small<{ color: string }>`
  font-size: 10px;
  color: ${(props) => props.color};
  display: flex;
  align-items: center;
  text-align: left;
  gap: 0.25rem;

  & span {
    display: block;
    aspect-ratio: 1/1;
    width: 6px;
    height: 6px;
    background: ${(props) => props.color};
    border-radius: 50%;
  }
`

export const SmallText = styled.small<{ color?: ThemeColors }>`
  font-size: 10px;
  text-align: left;
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 2px 0;

  color: ${(props) =>
    props.color
      ? getThemeColor(props.color, props.theme)
      : props.theme.colors.grey_1};
`

export const BoldText = styled.p`
  text-align: left;
  font-size: 10px;
  color: ${({ theme }) => theme.colors.grey_1};
  font-weight: 500;
`

export const CustomHandle = styled(Handle)`
  cursor: pointer;
  right: -10px;
  bottom: -10px;
  background: ${({ theme }) => theme.colors.secondary} url('/assets/plus.svg');
  width: 20px;
  height: 20px;
`

export const Badge = styled.small`
  color: ${({ theme }) => theme.colors.custom.purple};
  font-weight: 500;
  border: 1px solid ${({ theme }) => theme.colors.custom.purple};
  background-color: ${({ theme }) => `${theme.colors.custom.purple + '33'}`};
  padding: 0.2rem 0.5rem;
  border-radius: 50px;
`
